// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__Glv7e","right":"styles_right__2ywzY"};